import SignIn from '../features/Auth/components/signin/signin.module'

const SignInPage = () => <SignIn />

export default SignInPage